import { RouteObject } from 'react-router-dom';
import { ProtectedRoute } from '@components/ProtectedRoute/ProtectedRoute';
// Routes
import { ErrorPages } from '@components/ui/ErrorPages';
import { CoreBox } from '@youscience/core';
import { UnauthorizedLayout } from '@layouts/UnauthorizedLayout/UnauthorizedLayout';
import { CircularProgress } from '@mui/material';
import { groupsRoutes } from './groupsRoutes';
import { invitationsRoutes } from './invitationsRoutes';
import { organizationRoutes } from './organizationRoutes';
import { ROOT_ROUTES } from '.';
import { usersRoutes } from './usersRoutes';
import ErrorPage from '../error-page';
import { impersonationRoutes } from './impersonationRoutes';
import { d2cRoutes } from './d2cRoutes';
import { tagsRoutes } from './tagsRoutes';
import { adminUtilitiesRoutes } from './adminUtilitiesRoutes';
import { pathwaysRoutes } from './pathwaysRoutes';

export const rootRoutes: RouteObject[] = [
  {
    path: ROOT_ROUTES.BASE_ROUTE,
    element: <ProtectedRoute />,
    children: [
      ...organizationRoutes,
      ...usersRoutes,
      ...invitationsRoutes,
      ...groupsRoutes,
      ...impersonationRoutes,
      ...tagsRoutes,
      ...d2cRoutes,
      ...adminUtilitiesRoutes,
      ...pathwaysRoutes,
    ],
    errorElement: <ErrorPage sx={{ height: '100vh' }} />,
    hydrateFallbackElement: (
      <UnauthorizedLayout>
        <CircularProgress size={60} />
      </UnauthorizedLayout>
    ),
  },
  {
    // return to home page if not found
    path: '*',
    errorElement: <ErrorPage sx={{ height: '100vh' }} />,
    hydrateFallbackElement: (
      <UnauthorizedLayout>
        <CircularProgress size={60} />
      </UnauthorizedLayout>
    ),
    element: (
      <CoreBox sx={{ height: '100vh' }}>
        <ErrorPages errorType='not-found' homePageLink='https://brightpath.youscience.com/home' />
      </CoreBox>
    ),
  },
];
